var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import assert from 'assert';

var assertString = function assertString(obj) {
    assert(obj && typeof obj === 'string', 'String expected');
    return obj;
};

var assertFunction = function assertFunction(obj) {
    assert(typeof obj === 'function', 'Function expected');
    return obj;
};

var MenuItem = function () {
    function MenuItem(loc) {
        _classCallCheck(this, MenuItem);

        this._loc = assertString(loc);
    }

    _createClass(MenuItem, [{
        key: 'getLoc',
        value: function getLoc() {
            return this._loc;
        }
    }, {
        key: 'setSref',
        value: function setSref(sref) {
            this._sref = assertString(sref);
            return this;
        }
    }, {
        key: 'getSref',
        value: function getSref() {
            return this._sref;
        }
    }, {
        key: 'activeWhen',
        value: function activeWhen(condition) {
            this._active = assertFunction(condition);
            return this;
        }
    }, {
        key: 'isActive',
        value: function isActive($scope) {
            if (!this._active) {
                return false;
            }

            return this._active($scope);
        }
    }, {
        key: 'visibleWhen',
        value: function visibleWhen(condition) {
            this._visible = assertFunction(condition);
            return this;
        }
    }, {
        key: 'isVisible',
        value: function isVisible($scope) {
            if (!this._visible) {
                return true;
            }

            return this._visible($scope);
        }
    }]);

    return MenuItem;
}();

export default ['UserInfoService', function (UserInfoService) {
    var activitiesMenuItem = new MenuItem('app.html.index.Activities').setSref('activities.index').activeWhen(function ($scope) {
        return $scope.$state.includes('activities');
    });

    if (UserInfoService.isAgent()) {
        return [new MenuItem('app.html.index.Accounts').setSref('accounts.index').activeWhen(function ($scope) {
            return $scope.$state.includes('accounts') || $scope.$state.includes('gatewaybilling-invoice-payment') || $scope.$state.includes('gateway-billing-make-payment-confirmation') || $scope.$state.includes('policySelect') && $scope.getType() === 'account';
        }), new MenuItem('app.html.index.Policies').setSref('policies.index').activeWhen(function ($scope) {
            return $scope.$state.includes('policies') || $scope.$state.includes('policySelect') && $scope.getType() === 'policy';
        }), new MenuItem('app.html.index.Claims').setSref('claims').activeWhen(function ($scope) {
            return $scope.$state.includes('claims');
        }).visibleWhen(function ($scope) {
            return $scope.claimsFeatureTurnedOn;
        }),

        //activitiesMenuItem,

        new MenuItem('app.html.index.Analytics').setSref('reports').activeWhen(function ($scope) {
            return $scope.$state.includes('reports');
        }).visibleWhen(function ($scope) {
            return $scope.canViewReports;
        })];
    }

    return [activitiesMenuItem];
}];


//////////////////
// WEBPACK FOOTER
// ./app/js/portal/directives/NavBarItems.js
// module id = 1319
// module chunks = 0